// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"393":"aea79630","462":"bb86a21a","965":"af647906"}[chunkId] + ".chunk.css";
};